module.exports = __webpack_public_path__ + "static/media/more.40e56d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/more.mp3
// module id = 7+zR
// module chunks = 1 3